import { Card, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Cancel, Update } from "@material-ui/icons";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import * as React from "react";
import { useState } from "react";
import { BooleanInput, Button, NumberInput, TextInput, Toolbar, useNotify } from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { SectionTitle } from "../../../../../Components/SectionTitle";
import { Separator } from "../../../../../Components/Separator";
import { useAppDataProvider } from "../../../../../dataprovider";
import { RequestSptPutModel } from "../../../Models/RequestSptModel";
import { SourceRequestOrder } from "../../Constant/Source";

export const RequestSptEdit = props => {
  const [approveButtonShown, setApproveButtonShown] = useState(true);
  const [loading, setLoading] = useState(false);
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const { user } = useAuth();
  const { canPerform: canEditOnlyShow } = useAccessControl(SourceRequestOrder, "editonlyshow");
  const requestId = props.requestId;

  React.useEffect(() => {
    setApproveButtonShown(canEditOnlyShow);
  });

  const useStyles = makeStyles({
    toolbar: {
      flex: "auto",
      justifyContent: "end",
      backgroundColor: "white",
    },
    defaultToolbar: {
      flex: "auto",
      justifyContent: "end",
    },
  });

  const classes = useStyles();

  const UpdateRequestSptButtonClick = async e => {
    UpdateRequestSpt(e);
  };

  const UpdateRequestSpt = e => {
    let requestSptUpdateModel: RequestSptPutModel = new RequestSptPutModel();

    requestSptUpdateModel.id = props.requestSpt.id;
    requestSptUpdateModel.RequestId = props.requestSpt.requestId;
    requestSptUpdateModel.Spt = e.spt === undefined ? 0 : e.spt;
    requestSptUpdateModel.Remarks = e.remarks;
    requestSptUpdateModel.IsExcluded = e.isExcluded;
    requestSptUpdateModel.updatedBy = user?.employeeId;
    requestSptUpdateModel.updatedDate = new Date();

    dataProvider
      .putRequestSpt(requestSptUpdateModel)
      .then(result => {
        notify(`SPT Record updated`, "success", false, true);
        props.finalCallBack();
        history.push("/requestorders/" + requestId + "/6");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const cancelUpdate = () => {
    props?.finalCallBack?.();
  };

  return (
    <Form
      onSubmit={e => UpdateRequestSptButtonClick(e)}
      render={({ handleSubmit, form, values }) => (
        <form>
          <Card>
            <Grid container xs={12} spacing={1} justify="space-around" alignItems="center">
              <SectionTitle label="Request SPT" />
            </Grid>
            <Separator />
            <Grid container xs={12} spacing={1} justifyContent="center">
              <Grid item xs={12} sm={5}>
                <NumberInput
                  source="spt"
                  label="Request SPT"
                  variant="outlined"
                  disabled={!approveButtonShown}
                  defaultValue={props.requestSpt.spt}
                  fullWidth
                />
                <BooleanInput
                  label="IS EXCLUDED"
                  source="isExcluded"
                  disabled={!approveButtonShown}
                  defaultValue={props.requestSpt.isExcluded}
                />
              </Grid>
              <Grid item xs={12} sm={5}>
                <TextInput
                  source="remarks"
                  label="Remarks"
                  multiline
                  resettable
                  fullWidth
                  disabled={!approveButtonShown}
                  defaultValue={props.requestSpt.remarks}
                  rows={4}
                  variant="outlined"
                  FormHelperTextProps={{
                    style: { display: "block" },
                  }}
                />
              </Grid>
              <Separator />
            </Grid>
            <Toolbar {...props} placeholder="" classes={classes}>
              {approveButtonShown === true ? (
                <>
                  <Button
                    label={loading ? "Request SPT is updating!" : "Update Request SPT "}
                    disabled={loading}
                    size="medium"
                    variant="contained"
                    style={{ margin: "8px", background: "seagreen" }}
                    onClick={handleSubmit}
                  >
                    {loading ? <CircularProgress size="2rem" color="secondary" /> : <Update />}
                  </Button>
                  <Button
                    label={loading ? "Cancel!" : "Cancel "}
                    disabled={loading}
                    size="medium"
                    variant="contained"
                    color="primary"
                    style={{ margin: "8px" }}
                    onClick={cancelUpdate}
                  >
                    {<Cancel />}
                  </Button>
                </>
              ) : (
                <Grid></Grid>
              )}
            </Toolbar>
          </Card>
        </form>
      )}
    />
  );
};
export default RequestSptEdit;
